var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a0mLSf"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.4905 73C16.367 72.9931 -0.046556 56.5466 -0.00026855 36.434C0.0460189 16.3423 16.4225 -0.0023142 36.5044 2.45769e-07C56.6255 0.00231469 73.0437 16.4534 72.9974 36.5636C72.9511 56.6461 56.5584 73.0069 36.4905 73ZM11.7892 57.1715C18.2925 49.6194 26.2008 44.9998 36.4882 44.9929C46.8033 44.9859 54.7324 49.638 61.2543 57.2062C71.8009 44.9211 71.7916 25.1118 58.3544 12.6623C45.2504 0.52538 24.6802 1.43033 12.546 14.794C0.483436 28.0766 2.46454 46.8352 11.7892 57.1715Z",
    fill: "url(#paint0_linear_1_2349)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.4954 37.9708C30.404 37.9685 25.4605 33.0341 25.4651 26.9633C25.4698 20.8994 30.4364 15.9419 36.5024 15.9419C42.566 15.9419 47.5304 20.9041 47.535 26.9679C47.5396 33.0341 42.5845 37.9731 36.4977 37.9708H36.4954Z",
    fill: "url(#paint1_linear_1_2349)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2349",
    x1: 36.3646,
    y1: -11.7907,
    x2: 36.4433,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2349",
    x1: 36.4596,
    y1: 12.3839,
    x2: 36.4833,
    y2: 37.9708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.642f3d270a201990cfa83852ed8313f0.svg";
export { ForwardRef as ReactComponent };